/** ч.1216: зведені журнали «Комерції» — «Зведена реалізацій» (документи покупців) і
 *  «Зведена надходжень» (документи постачальників), як однойменні журнали 1С. */
import { api } from './client';

export type CommerceJournalSide = 'sales' | 'purchases';

export interface CommerceJournalRow {
  /** Вид документа в журналі (customer_invoice, goods_sale, bank_receipt, tax_invoice …). */
  kind: string;
  kind_label: string;
  /** Таблиця документа — для маршруту «відкрити документ». */
  document_type: string;
  id: string;
  document_date: string | null;
  /** false — дата без часу (податкові накладні). */
  has_time: boolean;
  document_number: string | null;
  amount: string | null;
  currency_code: string;
  contractor_id: string | null;
  contractor_name: string | null;
  contract_id: string | null;
  contract_name: string | null;
  contract_number: string | null;
  contract_date: string | null;
  organization_id: string;
  organization_name: string | null;
  responsible_name: string | null;
  comment: string | null;
  posted: boolean;
  external_source: string | null;
}

export interface CommerceJournalKind { code: string; label: string }

export interface CommerceJournalPage {
  items: CommerceJournalRow[];
  total: number;
  limit: number;
  offset: number;
  /** Види документів, доступні користувачу в цьому журналі (для фільтра). */
  kinds: CommerceJournalKind[];
}

export interface CommerceJournalParams {
  organization_id?: string;
  contractor_id?: string;
  kind?: string[];
  posted?: boolean;
  q?: string;
  date_from?: string;
  date_to?: string;
  sort_by?: string;
  sort_dir?: 'asc' | 'desc';
  limit: number;
  offset: number;
}

export const commerceJournal = {
  list: (side: CommerceJournalSide, params: CommerceJournalParams) =>
    api.get<CommerceJournalPage>(`/commerce-journal/${side}`, {
      params,
      // kind=a&kind=b (FastAPI list[str]), а не kind[]=a
      paramsSerializer: { indexes: null },
    }).then((r) => r.data),
};
